export default {
  name: 'customerType',
  data() {
    return {
      menuList: [],
      menuProps: {
        children: 'childrenList',
        label: 'custTypeNameCn'
      },
      menuSeled: [],
      menuDefaultChecked: [],
      menuDefaultShow: [], // 默认展开层级
      menuDefaultShow2: [], // 默认展开获取父级删除后展开使用
      btnDisabled: true,
      custTypeDetail: {
        custTypeId: '',
        createTime: '',
        creator: '',
        custTypeCode: '',
        custTypeDesc: '',
        custTypeNameCn: '',
        custTypeNameEn: '',
        parentTypeCode: '',
        parentTypeName: ''
      },
      menuNode: {},
      userList: [],
      userNone: false,
      custForm: {
        custTypeNameCn: '',
        custTypeNameEn: '',
        custTypeDesc: ''
      },
      dialogTitle: {
        addSameOrg: '添加一级客户类型',
        addSubOrg: '添加子级客户类型'
      },
      dialogStatus: '',
      dialogFormVisible: false,
      rules: {
        custTypeNameCn: [
          { required: true, message: '请填写客户类型名称', trigger: 'blur' }
        ],
        custTypeNameEn: [
          { required: true, message: '请填写类型英文名称', trigger: 'blur' },
          { validator: this.regular.englishName, trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  created() {
    this.queryMenuList()
  },
  methods: {
    queryMenuList() {
      this.btnDisabled = true
      let _self = this
      /* 查询客户类型列表 */
      this.$http
        .get(this.$API.customerManagement.queryCustTypeTree, {})
        .then(function(r) {
          _self.menuList = r.data.resData
          if (_self.menuList.length) {
            // 请求详情
            _self.queryDetail(_self.menuList[0].custTypeId)
          } else {
            _self.menuSeled = []
          }
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    queryDetail(item) {
      item
        ? (this.menuSeled = item)
        : (this.menuSeled = this.menuList[0].custTypeId)
      let params = {
        custTypeId: this.menuSeled
      }
      if (this.menuDefaultShow.length) {
        params.custTypeId = this.menuDefaultShow.join('')
      }
      let _self = this
      /* 查询组织详情 */
      this.$http
        .get(this.$API.customerManagement.queryCustTypeById, { params: params })
        .then(function(r) {
          _self.custTypeDetail = r.data.resData
          _self.custTypeDetail.custTypeId = params.custTypeId
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    menuNodeClick(item, data) {
      this.menuDefaultShow = []
      this.menuDefaultShow.push(item.custTypeId)
      // 删除所用的menuDefaultShow2
      this.menuDefaultShow2 = []
      if (!Array.isArray(data.parent.data)) {
        this.menuDefaultShow2.push(data.parent.data.custTypeId)
      }
      this.menuNode = item
      this.btnDisabled = false
      this.queryDetail(item.custTypeId)
    },
    /* 保存客户类型详情 */
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.custTypeDetail.custTypeId) {
            let _self = this
            let params = {
              custTypeId: this.custTypeDetail.custTypeId,
              custTypeDesc: this.custTypeDetail.custTypeDesc,
              custTypeNameCn: this.custTypeDetail.custTypeNameCn,
              custTypeNameEn: this.custTypeDetail.custTypeNameEn
            }
            /* 保存编辑组织信息 */
            this.$http
              .post(this.$API.customerManagement.editCustType2, params)
              .then(function(r) {
                _self.$message({
                  message: '保存成功',
                  type: 'success'
                })
                _self.queryMenuList()
              })
              .catch(function(error) {})
          } else {
            return false
          }
        }
      })
    },
    closeDialog(formName) {
      this.dialogFormVisible = false
      this.$refs[formName].resetFields()
    },
    addSameOrg() {
      this.dialogFormVisible = true
      this.dialogStatus = 'addSameOrg'
    },
    addSubOrg(node, data) {
      this.custTypeDetail.custTypeId = data.custTypeId
      this.dialogFormVisible = true
      this.dialogStatus = 'addSubOrg'
    },
    delOrg(node, data) {
      this.$confirm('确认删除此客户类型？', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          /* 获取父级id作为默认展开层级 */
          this.menuDefaultShow = []
          this.menuDefaultShow = this.menuDefaultShow.concat(
            this.menuDefaultShow2
          )
          let _self = this
          this.$http
            .post(this.$API.customerManagement.delCustType2, {
              custTypeId: data.custTypeId
            })
            .then(function(r) {
              _self.$message({
                type: 'success',
                message: '删除成功'
              })
              _self.queryMenuList()
            })
            .catch(function(error) {
              console.log(error)
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    saveAddOrg(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let _self = this
          let params = {
            custTypeDesc: this.custForm.custTypeDesc,
            custTypeNameCn: this.custForm.custTypeNameCn,
            custTypeNameEn: this.custForm.custTypeNameEn
          }
          /* 判断弹窗状态值, 新增同级/子级保存 parentId 参数值不同 */
          if (this.dialogStatus == 'addSameOrg') {
            /* 始终添加一级 */
            params.parentTypeId = ''
            this.menuDefaultShow = []
          } else if (this.dialogStatus == 'addSubOrg') {
            params.parentTypeId = this.custTypeDetail.custTypeId
          }
          this.$http
            .post(this.$API.customerManagement.addCustType2, params)
            .then(function(r) {
              _self.dialogFormVisible = false
              _self.$message({
                message: '新增成功',
                type: 'success'
              })
              _self.queryMenuList()
            })
            .catch(function(error) {
              console.log(error)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/customerManagement/customerType.js